export const OrganizationTypes = {
  CLINIC: 'healthcare',
  LAW: 'attorney',
  INDIVIDUAL: 'individual'
}
